import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import withStyles from '@material-ui/core/styles/withStyles';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import get from "lodash/get";
import Dropzone from "react-dropzone";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from '@material-ui/icons/Add';
import moment from "moment";
import { getFormattedImageLink, getFormattedDate } from "../../../../../../../Utils";
import { instance, instanceMultipart } from "../../../../../../../Actions/AxiosInstance";


const styles = () => ({
  root: {
    marginBottom: '8px',
  },
  textArea: {
    marginBottom: '20px',
  },
  textMessage: {
    marginTop: '10px',
    marginBottom: '10px',
    fontSize: '14px',
    color: '#010709',
    opacity: '0.7',
    '& p': {
      margin: 0,
      fontSize: '14px',
      color: '#010709',
    },
  },
  actionCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  duedateText: {
    margin: 0,
    fontSize: 12,
    color: '#010709',
    opacity: '0.7',
  },
  actionSection: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  paragrah: {
    margin: 0,
    fontSize: '14px',
    color: '#010709',
    opacity: '0.7',
    marginBottom: '10px',
  },

});


class UpLoadRequest extends Component {
  state = {
    activitytypeid: 5,
    title: null,
    message: null,
    duedays: 0,
    files: [],
    doneButton: null,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.activityObject.isdone !== state.doneButton) {
      const object = { ...state, doneButton: props.activityObject.isdone };
      return object;
    }
    return null;
  }

  onDoneConfirmation(item) {
    const { checklist } = this.props;
    if( checklist && checklist.isseqcompletion == false ){
        this.props.enqueueSnackbar("Are you sure this is done?", {
          variant: "warning",

          action: [
            <Button
              color="inherit"
              size="small"
              onClick={() => this.onDone(item)}
            >
              Done
            </Button>,

            <Button
              color="inherit"
              size="small"
              onClick={() => {
                //this.setState({ isEdit: false });
                this.props.closeSnackbar();
              }}
            >
              Cancel
            </Button>,
          ],
        });
    }else if( checklist && checklist.isseqcompletion == true ){
      this.props.enqueueSnackbar("Please mark as done only when the activity is complete. Sequential activities cannot be undone, are you sure this is done?", {
        variant: "warning",

        action: [
          <Button
            color="inherit"
            size="small"
            onClick={() => {
              this.onDone(item);
              this.props.closeSnackbar();}}
            
          >
            Done
          </Button>,

          <Button
            color="inherit"
            size="small"
            onClick={() => {
              //this.setState({ isEdit: false });
              this.props.closeSnackbar();
              this.props.reloadChecklistOnDone(this.props.checklist);
            }}
          >
            Cancel
          </Button>,
        ],
      });
    }
  }

  async onDone(done) {
    try {
      if (!(this.state.files.length > 0)) {
        this.props.enqueueSnackbar("Please upload the requested files", { variant: "error" });
        return;
      } else if (!(this.state.files.length <= 10)) {
        this.props.enqueueSnackbar("Cannot upload more than 10 requested files", { variant: "error" });
        return;
      }
      await instance.post(`checklist/empuploadactivity`, {
        isdone: done,
        empchecklistid: this.props.postData.empchecklistid,
        empchecklistactivityid: this.props.activityObject.empchecklistactivityid,
        checklistactivityid: this.props.activityObject.checklistactivityid,
        isshared: this.props.isShared,
        datapath: this.state.files,
      });
      this.props.enqueueSnackbar("Successfully", { variant: "success" });
      this.props.reloadChecklistOnDone(this.props.checklist);
    } catch (error) {
      this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: "error" });
    }
  }

  componentDidMount = () => {
    if (this.props.activityObject) {
      this.setState({
        title: this.props.activityObject.title,
        message: this.props.activityObject.message,
        duedays: this.props.activityObject.duedays,
        doneButton: this.props.activityObject.isdone,
        files: this.props.activityObject.datapath || [],
      });
    }
  };

  OnFieldChange = (value) => {
    this.setState({ message: value });
  };

  updatePostData = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  handleFileDrop = async (files) => {
    try {
      console.log(files);
      console.log('subscriptionsubscription', this.props.SubscriptionInfo);
      const file = files[0];
      const formData = new FormData();
      formData.append("file", file);
      const fileUploaded = await instanceMultipart.post(
        `/subscription/uploaddefault/${get(this.props, "SubscriptionInfo.SubscriptionData.accountid", "")}/${get(this.props, "SubscriptionInfo.SubscriptionData.subscriptionid", "")}/2`,
        formData,
      );
      console.log(fileUploaded.data.result[0]);
      const filesArray = this.state.files;
      filesArray.push({
        datapath: fileUploaded.data.result[0].imagepath,
        datatypeid: 2,
        isdatastored: true,
      });
      this.setState({
        files: filesArray,
      });
    } catch (error) {
      console.log(error);
    }
  };

  fileSelectedHandler = (e) => {
    this.setState({ files: [...this.state.files, ...e.target.files] });
  };

  removeImageFromFiles = (event, index) => {
    const { doneButton } = this.state;
    event.stopPropagation();
    const filesArrayCopy = this.state.files;
    filesArrayCopy.splice(index, 1);
    if (!doneButton) {
      this.setState({
        files: filesArrayCopy,
      });
    }
  };

  render() {
    const { message, duedays, fullname, doneon, isallowedone } = this.props.activityObject;
    const { classes, checklist } = this.props;
    const effectiveDate = moment(checklist.effectivefrom);
    effectiveDate.add(duedays, 'days');
    const currentDate = moment();
    return (
      <Grid container className={classes.root} direction='row'>
        <Grid item xs={12} className={classes.textArea}>
          <div dangerouslySetInnerHTML={{ __html: message }} className={classes.textMessage}>
          </div>
        </Grid>
        <Grid item xs={12}>
          <p className={classes.paragrah}>Please upload requested files</p>
          <Dropzone
            onDrop={this.handleFileDrop}
            disabled={this.state.files.length == 10 || this.state.doneButton || !checklist.isactive}
            multiple={false}
            accept="image/gif, image/jpeg, image/png, application/pdf"
            maxSize={2000000}
            className={`mediaFileUploader ${this.state.files.length ? 'imageFilled' : null}`}
            label=" Drag & upload">
            {
              this.state.files.length
                ? <Grid container className='imageThumbContainer'>
                  {
                    this.state.files.map((file, index) => (
                      <div className="image-uploaded input-area-section" key={`checklist-image-${index}`}>
                        <img src={file.datapath && getFormattedImageLink(file.datapath)} />
                        <CloseIcon className="remove-icon" style={{ display: (this.state.doneButton || !checklist.isactive) ? 'none' : 'block' }}
                          onClick={(event) => { this.removeImageFromFiles(event, index); }}
                        />
                      </div>))
                  }
                  <div className='addMoreButton' style={{ display: (this.state.files.length === 10 || this.state.doneButton || !checklist.isactive) ? 'none' : 'flex' }}>
                    <AddIcon />
                    <p> Add Files</p>
                  </div>
                </Grid>
                : <Grid item className='noImageContent'>
                  <CloudUploadIcon />
                  <p> Drag & upload </p>
                </Grid>
            }
          </Dropzone>
          <p className="input-label">
              Note:<br></br>
                Supported files: .gif, .jpeg, .png and .pdf<br></br>
                Max size: 2MB
            </p>
        </Grid>
        <Grid xs={12} className={classes.actionCenter}>
          <Grid xs={8}>
            {this.state.doneButton
              ? <p className={classes.duedateText}> {fullname} completed this on {getFormattedDate(doneon)}</p>
              : checklist.effectivefrom ? <p className={classes.duedateText}>Due {currentDate.to(effectiveDate)} </p> : <p className={classes.duedateText}>No Due Date</p>}
          </Grid>
          <Grid xs={4} className={classes.actionSection}>
            {this.state.doneButton == false ? <Button color="primary" className="btn btn-primary-sm-blue" variant="contained" onClick={() => this.onDoneConfirmation(true)} disabled={!isallowedone}> Done </Button>
              : checklist.isseqcompletion == false ? <Button color="primary" className="btn" classes={{ root: "bgcolor-dodgerRed" }} variant="contained" onClick={() => this.onDoneConfirmation(false)} disabled={!checklist.isactive} > Undo </Button> : ""}
          </Grid >
        </Grid >
        {checklist.isseqcompletion == true && isallowedone== false && this.state.doneButton == false &&( 
        <Grid xs={12} style={{marginTop:8}}>
          <p className="input-label">
            Note: You can't complete this sequential activity until the preceding activity is complete.
          </p>
        </Grid>
      )}
      </Grid >
    );
  }
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
});

export default connect(mapStateToProps)(withSnackbar(withStyles(styles)(UpLoadRequest)));
